import { withNoopInstall } from '../../utils/install';

import SkeletonItem from './index.vue';

export const IvueSkeletonItem = withNoopInstall(SkeletonItem);

export default IvueSkeletonItem;

export * from './index.vue';
